import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CustomersService } from "../../../../../services/customers.service";
import { UnitssService } from "../../../../../services/unitss.service";

interface Cliente {
	id: number | null;
	name: string;
}

interface Unidad {
	id: number;
	name: string;
}

/*
 * Interface de una unidad.
 */
interface Unidad {
	id: number;
	name: string;
	is_connected: number;
}

/*
 * Interface de respuesta del servicio.
 */
interface UnitsResponse {
	success: boolean;
	totals: {
		connected: number;
		disconnected: number;
		all: number;
	};
	connected: Unidad[];
	disconnected: Unidad[];
}

/*
 * Componente modal para seleccionar rango de fechas, cliente y unidad.
 * Permite emitir la información seleccionada al componente padre.
 */
@Component({
	selector: "app-client-modal",
	templateUrl: "./client-modal.component.html",
	styleUrls: ["./client-modal.component.scss"],
})
export class ClientModalComponent {
	@Input() clientes: Cliente[] = [];
	@Input() visible: boolean = false;
	@Input() selectedClientId: number | null = null;

	@Output() onAccept = new EventEmitter<any>();
	@Output() onCancel = new EventEmitter<void>();

	fechaInicio: string | null = null;
	fechaFinal: string | null = null;

	selectedUnitIds: number[] = [];
	unidades: Unidad[] = [];

	/*
	 * Define el tipo de visualización de evidencias.
	 * no = sin evidencias
	 * compact = máximo 3 evidencias
	 * full = todas las evidencias
	 */
	evidence_layout: "no" | "compact" | "full" = "compact";

	constructor(
		private customersService: CustomersService,
		private UnitssService: UnitssService,
	) {}

	/*
	 * Ejecuta la lógica necesaria cuando se selecciona un cliente.
	 * Si no hay cliente seleccionado, limpia la unidad y la lista de unidades.
	 */
	async onClienteChange(): Promise<void> {
		this.selectedUnitIds = [];
		this.unidades = [];

		if (!this.selectedClientId) {
			return;
		}

		/*
		 * Ajusta este método según el nombre real de tu servicio.
		 * Ejemplo esperado: obtener unidades por cliente.
		 */
		const units: any = await this.UnitssService.getBUnitsByClient(
			this.selectedClientId,
		);

		this.unidades = [...units];
	}

	/*
	 * Emite al componente padre las fechas, el cliente y la unidad seleccionada.
	 */
	aceptar(): void {
		const ahora = new Date();

		const fecha = [
			ahora.getFullYear(),
			String(ahora.getMonth() + 1).padStart(2, "0"),
			String(ahora.getDate()).padStart(2, "0"),
		].join("-");

		const hora = [
			String(ahora.getHours()).padStart(2, "0"),
			String(ahora.getMinutes()).padStart(2, "0"),
			String(ahora.getSeconds()).padStart(2, "0"),
		].join("-");

		const nombreReporte = `Reporte_Unidades_${fecha}_${hora}`;
		this.onAccept.emit({
			nombreReporte,
			start: this.fechaInicio,
			end: this.fechaFinal,
			client_id: this.selectedClientId,
			unit_ids: this.selectedUnitIds,
			evidence_layout: this.evidence_layout,
		});

		this.visible = false;
	}

	/*
	 * Cierra el modal sin aplicar cambios.
	 */
	cancelar(): void {
		this.onCancel.emit();
		this.visible = false;
	}
}
